<template>
  <div class="flex flex-col gap-4">
    <div v-if="agentSynthesis.length" data-test="agent-synthesis">
      <div class="mb-1 flex items-center justify-between gap-3">
        <span class="text-sm font-medium text-gray-900">{{ t("agent_synthesis") }}</span>
        <span class="text-xs text-gray-500">{{ t("not_sent_to_client") }}</span>
      </div>
      <ul class="space-y-1 rounded-lg bg-green-50 px-4 py-3 text-sm text-green-900">
        <li v-for="(line, index) in agentSynthesis" :key="index" class="flex items-start gap-2">
          <CheckCircleIcon class="mt-0.5 h-4 w-4 shrink-0 text-green-700" aria-hidden="true" />
          <span>{{ line }}</span>
        </li>
      </ul>
    </div>

    <Textarea
      id="approveEstalyManagerNotes"
      v-model="internalNotes"
      :label="t('internal_notes')"
      label-class="block text-sm font-medium leading-6 text-gray-900"
      data-test="internal-notes"
    />

    <div class="flex flex-wrap items-center justify-between gap-3">
      <p class="text-sm text-gray-500">{{ t("next_step") }}</p>
      <GenericButton
        default-style="bg-green-700 hover:bg-green-800 border-transparent text-white"
        :disabled="submitting"
        data-test="confirm"
        @click="submit"
      >
        {{ t("confirm") }}
      </GenericButton>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import { CheckCircleIcon } from "@heroicons/vue/solid";
import { GenericButton, Textarea } from "@estaly/ui";

export default {
  name: "ClaimApproveForm",

  components: { CheckCircleIcon, GenericButton, Textarea },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    // Synthèse de l'agent quand il recommande l'approbation : rappel pour l'ops, jamais envoyé au client.
    agentSynthesis: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["confirmed"],

  data() {
    return {
      internalNotes: "",
      submitting: false,
    };
  },

  methods: {
    ...mapActions("claims", ["approveClaim"]),

    // Aucun motif client n'accompagne une approbation : seul le commentaire interne part.
    async submit() {
      this.submitting = true;
      const response = await this.approveClaim({
        internalNotes: this.internalNotes || null,
        customerMessage: null,
      });
      this.submitting = false;

      if (response?.success) this.$emit("confirmed");
    },
  },
};
</script>

<i18n src="./ClaimApproveForm.i18n.json"></i18n>
